import { LIVE } from '@/routes/config/paths';
import {
  Reception,
  PollEmbed,
  LiveForum,
  DiscussionImageDashboard,
  Participants,
  Expo,
  MingleLarge,
  EntityViewFullscreen,
  EntitySlideShow,
  EntityListDashboard,
  LiveRoom,
  Session,
  BundleRoute,
} from '@/routes/config/elements';
import { RoomPollAndMessage, EventAndPoll } from '@/routes/config/providers';

/** Single route when welcomeState is true (welcome screen). */
export const liveWelcomeRoutes = [
  {
    path: LIVE.BASE,
    Component: Reception,
    props: { state: 'welcome' },
  },
];

/** Main live routes when welcomeState is false. */
export const liveRoutes = [
  { path: LIVE.BASE, Component: Reception },
  {
    path: LIVE.POLL,
    Component: PollEmbed,
    props: () => ({ conferencename: window.CONFERENCE_NAME }),
  },
  { path: LIVE.DISCUSSION, Component: LiveForum },
  { path: LIVE.DISCUSSION_IMAGES, Component: DiscussionImageDashboard },
  { path: LIVE.DISCUSSION_TOPIC, Component: LiveForum },
  { path: LIVE.PARTICIPANTS, Component: Participants },
  { path: LIVE.EXPO, Component: Expo },
  { path: LIVE.MEET, Component: MingleLarge },
  { path: LIVE.ITEM, Component: EntityViewFullscreen },
  { path: LIVE.ITEM_SLIDESHOW, Component: EntitySlideShow },
  { path: LIVE.LIST, Component: EntityListDashboard },
  { path: LIVE.LIST_ITEM, Component: EntityViewFullscreen },
  { path: LIVE.LIST_ITEM_SLIDESHOW, Component: EntitySlideShow },
  {
    path: LIVE.ROOM,
    Component: LiveRoom,
    providers: [RoomPollAndMessage],
    props: null, // user injected in LiveRoutes.js from authState
  },
  {
    path: LIVE.SESSION_ROOM,
    Component: Session,
    providers: [EventAndPoll],
    props: () => ({ conferencename: window.CONFERENCE_NAME }),
  },
  {
    path: LIVE.SESSION,
    Component: Session,
    providers: [EventAndPoll],
    props: () => ({ conferencename: window.CONFERENCE_NAME }),
  },
  {
    path: '*',
    Component: BundleRoute,
    props: { bundle: 'live' },
  },
];
